var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "회원탈퇴"
    },
    scopedSlots: _vm._u([{
      key: "contents",
      fn: function () {
        return [_c('v-tabs-items', {
          attrs: {
            "value": _vm.tab
          }
        }, [_c('v-tab-item', {
          attrs: {
            "value": "info"
          }
        }, [_c('h5', {
          staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
        }, [_c('span', [_vm._v(" 탈퇴안내 ")])]), _c('ul', {
          staticClass: "letter-list"
        }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("회원탈퇴 시 연관 데이터가 모두 삭제되며, 동일한 아이디로 재가입 하더라도 복원되지 않습니다.")])])]), _c('div', {
          staticClass: "mt-30 mt-md-50"
        }, [_c('div', {
          staticClass: "v-btn--group v-btn--group--large"
        }, [_c('v-btn', _vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "color": "primary",
            "to": "/dashboard/withdraw/action"
          }
        }, 'v-btn', {
          loading: _vm.loading
        }, false), [_c('span', [_vm._v(" 계속하기 ")])])], 1)])]), _c('v-tab-item', {
          attrs: {
            "value": "action"
          }
        }, [_c('h5', {
          staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
        }, [_c('span', [_vm._v(" 탈퇴정보 ")])]), _c('vertical-form-table', _vm._b({
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        }, 'vertical-form-table', {
          items: _vm.items
        }, false)), _c('div', {
          staticClass: "mt-30 mt-md-50"
        }, [_c('div', {
          staticClass: "v-btn--group v-btn--group--large"
        }, [_c('v-btn', _vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "outlined": "",
            "color": "grey-cb",
            "to": "/dashboard/withdraw",
            "exact": ""
          }
        }, 'v-btn', {
          loading: _vm.loading
        }, false), [_c('span', {
          staticClass: "primary--text"
        }, [_vm._v("취소")])]), _c('v-btn', _vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "color": "primary"
          },
          on: {
            "click": _vm.withdraw
          }
        }, 'v-btn', {
          loading: _vm.loading
        }, false), [_vm._v("탈퇴신청")])], 1)])], 1)], 1)];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }